export default "__VITE_ASSET__DB5kNzLk__"